module.exports = __webpack_public_path__ + "static/IMG_6710-6e289eaf751a0f49ba3aa6169f09caa7.jpg";